import PropTypes from 'prop-types';
import hexRgba from 'hex-rgba';

function ImagemapTemplate1({ selected, color, width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0,0,154,154"
    >
      <rect
        width="154"
        height="154"
        y="27"
        fill={selected ? color : hexRgba(color, 10)}
        fillRule="evenodd"
        rx="8"
        transform="translate(0 -27)"
      />
    </svg>
  );
}

ImagemapTemplate1.defaultProps = {
  selected: false,
  color: '#2A394D',
  width: 154,
  height: 154,
};

ImagemapTemplate1.propTypes = {
  selected: PropTypes.bool,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ImagemapTemplate1;
